module.exports = __webpack_public_path__ + "static/vista-2-2a205df9ed7605f032d3bcd99f4b876c.jpeg";